import React from 'react';
import { Typography } from '@mui/material';
import { jwtDecode } from 'jwt-decode';

function AdminDashboard() {
  const token = "true";

  let userfullname = '';
  if (token) {
    try {
     // const decoded = jwtDecode(token);
      userfullname = localStorage.getItem('userfullname');
    } catch (e) {
      console.error('Invalid token', e);
    }
  }





  return (
    <Typography variant="h5">
      Welcome Admin  <strong>{userfullname}</strong> 👑
    </Typography>
  );
}

export default AdminDashboard;
